module.exports = __webpack_public_path__ + "static/media/Heart.be079d4d.svg";